import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

const BieberHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const sections = [
    { id: 'hero', label: 'Start' },
    { id: 'geschichte', label: 'Geschichte' },
    { id: 'galerie', label: 'Bilder' },
    { id: 'aktivitaeten', label: 'Aktivitäten' },
    { id: 'kontakt', label: 'Kontakt' }
  ];

  const scrollToSection = (id: string) => {
    // If not on the main bieber-info page, navigate there first
    if (location.pathname !== '/bieber-info') {
      window.location.href = '/bieber-info#' + id;
      return;
    }
    
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const scrollToTop = () => {
    // If not on the main bieber-info page, navigate there first
    if (location.pathname !== '/bieber-info') {
      window.location.href = '/bieber-info';
      return;
    }
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-40 transition-colors duration-300" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo/Brand */}
          <div className="flex items-center space-x-4">
            <button
              onClick={scrollToTop}
              className="text-2xl font-bold transition-colors duration-200 hover:opacity-80"
              style={{ color: 'var(--bieber-primary-color, #2d5a2f)' }}
            >
              Liederkranz Bieber
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className="text-lg font-medium transition-colors duration-200 hover:opacity-80"
                style={{ color: 'var(--text-primary)' }}
              >
                {section.label}
              </button>
            ))}
            <Link
              to="/"
              className="text-lg font-medium transition-colors duration-200 hover:opacity-80"
              style={{ color: 'var(--text-primary)' }}
            >
              Zu StimmArt
            </Link>
            <ThemeToggle />
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-4">
            <ThemeToggle />
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 transition-colors duration-200 hover:opacity-80"
              style={{ color: 'var(--text-primary)' }}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t transition-colors duration-300" style={{ borderColor: 'var(--bg-secondary)' }}>
            <nav className="flex flex-col space-y-4">
              {sections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => scrollToSection(section.id)}
                  className="text-lg font-medium text-left transition-colors duration-200 hover:opacity-80"
                  style={{ color: 'var(--text-primary)' }}
                >
                  {section.label}
                </button>
              ))}
              <Link
                to="/"
                className="text-lg font-medium transition-colors duration-200 hover:opacity-80"
                style={{ color: 'var(--text-primary)' }}
              >
                Zu StimmArt
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default BieberHeader; 